import axios from "axios";
import { common } from "../../utils";
import { API_URL } from "../../utils/api-utils";

export const GetListJobSchedule = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobSchedule`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const getInitScreen = async (param) => {
  let url = `${API_URL.Loader}/api/Job/InitScreen`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetJobInfo = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetJobInfo`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const GetListJobScheduleHistory = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListJobScheduleHistory`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveJobSchedule = async (param) => {
  let url = `${API_URL.Loader}/api/Job/SaveJobSchedule`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const SaveEditJobSchedule = async (param) => {
  let url = `${API_URL.Loader}/api/Job/SaveEditJobSchedule`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const DeleteJobSchedule = async (param) => {
  let url = `${API_URL.Loader}/api/Job/DeleteJobSchedule`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
export const CheckSlotJobAvailable = async (param) => {
  let url = `${API_URL.Loader}/api/Job/CheckSlotJobAvailable`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetConnectInfo = async (param) => {
  let url = `${API_URL.Query}/api/Query/GetConnectDB`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
}

export const ConnectDatabase = async (param) => {
  let url = `${API_URL.Query}/api/Query/GetConnectDB`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
}

export const CheckQuataAddJobByUser = async (param) => {
  let url = `${API_URL.Loader}/api/Job/CheckQuataAddJobByUser`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const CheckJobNameDulpicate = async (param) => {
  let url = `${API_URL.Loader}/api/Job/CheckJobNameDulpicate`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetListNotice = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetListNotice`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const GetNotAvalableTime = async (param) => {
  let url = `${API_URL.Loader}/api/Job/GetNotAvalableTime`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const CheckConnectDB = async (param) => {
  let url = `${API_URL.Loader}/api/Job/CheckConnectDB`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const ClearConnectDB = async (param) => {
  let url = `${API_URL.Loader}/api/Job/ClearConnectDB`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};

export const DownloadFile = async (param) => {
  let url = `${API_URL.Loader}/api/Job/DownloadFile`;
  let { result } = await common.to(axios.post(url, param));
  if (result && result.data) return result.data;
};
